const CurrentDate = ({ format = 'DDMMYY', date }) => {
  const D = date ? new Date(date) : new Date();
  const DAY = D.getDate();
  const MONTH = D.getMonth();
  const YEAR = D.getFullYear();
  const months = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre'
  ];

  const formats = {
    DDMMYY: `${DAY} de ${months[MONTH]} de ${YEAR}`,
    DDMM: `${DAY} de ${months[MONTH]}`,
    MMYY: `${months[MONTH]} de ${YEAR}`,
    YY: `${YEAR}`,
    'DD/MM/YY': `${DAY}/${MONTH + 1}/${YEAR}`,
    'DD-MM-YY': `${DAY}-${MONTH + 1}-${YEAR}`
  };

  return formats[format];
};

export const normalizeISODate = date =>
  date.replace(/-/g, '/').replace('T', ' ');

export default CurrentDate;
